import env from '@beam-australia/react-env'

export interface Envs {
  apiUrl: string
  wsUrl: string
  backendAppVersion: string
  bypassLogin: boolean
  env: string
  showEnvBadge: boolean
  mockedBackend: boolean
}

export const getEnvs = (): Envs => ({
  apiUrl: env('API_URL'),
  wsUrl: env('WS_URL'),
  backendAppVersion: env('BACKEND_APP_VERSION'),
  bypassLogin: env('BYPASS_LOGIN') === 'true',
  env: env('ENV'),
  showEnvBadge: env('SHOW_ENV_BADGE') === 'true',
  mockedBackend: false,
})
